import { endpoints } from "../../services/endpoints";
import { getJson, postJson } from "../../services/httpClient";
import { extractTokenSubject } from "../../utils/jwt";

function extractFirst(payload) {
  return Array.isArray(payload?.data) ? payload.data[0] || null : null;
}

export async function loginWithPassword(credentials) {
  const payload = await postJson(endpoints.auth.signIn, credentials);
  return extractFirst(payload);
}

function toDisplayRole(authority) {
  const normalizedAuthority = String(authority || "").trim();

  if (normalizedAuthority === "ROLE_ADMIN") {
    return "Admin";
  }

  if (normalizedAuthority === "ROLE_USER") {
    return "User";
  }

  return normalizedAuthority.replace(/^ROLE_/, "").replace(/_/g, " ") || "";
}

function resolveDisplayRole(record, tokenRoles = []) {
  const tokenAuthority = tokenRoles.find(Boolean);

  if (tokenAuthority) {
    return toDisplayRole(tokenAuthority);
  }

  const authorities = Array.isArray(record?.authorities) ? record.authorities : [];
  const authority =
    authorities
      .map((entry) => String(entry?.authority || "").trim())
      .find(Boolean) || "";

  return toDisplayRole(authority);
}

export function mapProfileToSessionUser(record, tokenRoles = []) {
  return {
    id: String(record?.id || ""),
    name: String(record?.fullName || "").trim(),
    email: String(record?.email || "").trim().toLowerCase(),
    role: resolveDisplayRole(record, tokenRoles),
    phone: String(record?.phoneNumber || "").trim(),
    location: "",
    timezone: "Asia/Kolkata",
    status: String(record?.status || "").trim(),
  };
}

export async function fetchCurrentUserProfile(accessToken) {
  const userId = extractTokenSubject(accessToken);

  if (!userId) {
    throw new Error("Could not determine the current user from the access token.");
  }

  const payload = await getJson(endpoints.auth.userById(userId), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return extractFirst(payload);
}
